import WebsiteConfig from './WebsiteConfig';

export default WebsiteConfig;
